import React, { useState, useEffect } from 'react';
import { X, Send, MessageCircle } from 'lucide-react';
import { handleFormSubmission, getCountryInfo } from '../services/api';

const RegistrationModal = ({ isOpen, onClose, initialType = 'registration' }) => {
  const [formData, setFormData] = useState({
    name: '',
    countryCode: '+1',
    phone: '',
    email: '',
    brandName: '',
    message: '',
    serviceType: initialType
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');

  const countryCodes = [
    { code: '+1', country: 'US', flag: '🇺🇸', length: 10, name: 'United States' },
    { code: '+1', country: 'CA', flag: '🇨🇦', length: 10, name: 'Canada' },
    { code: '+44', country: 'GB', flag: '🇬🇧', length: 10, name: 'United Kingdom' },
    { code: '+91', country: 'IN', flag: '🇮🇳', length: 10, name: 'India' },
    { code: '+61', country: 'AU', flag: '🇦🇺', length: 9, name: 'Australia' },
    { code: '+92', country: 'PK', flag: '🇵🇰', length: 10, name: 'Pakistan' },
    { code: '+86', country: 'CN', flag: '🇨🇳', length: 11, name: 'China' },
    { code: '+81', country: 'JP', flag: '🇯🇵', length: 10, name: 'Japan' },
    { code: '+49', country: 'DE', flag: '🇩🇪', length: 10, name: 'Germany' },
    { code: '+33', country: 'FR', flag: '🇫🇷', length: 9, name: 'France' },
    { code: '+39', country: 'IT', flag: '🇮🇹', length: 10, name: 'Italy' },
    { code: '+34', country: 'ES', flag: '🇪🇸', length: 9, name: 'Spain' },
    { code: '+52', country: 'MX', flag: '🇲🇽', length: 10, name: 'Mexico' },
    { code: '+55', country: 'BR', flag: '🇧🇷', length: 11, name: 'Brazil' },
    { code: '+27', country: 'ZA', flag: '🇿🇦', length: 9, name: 'South Africa' },
    { code: '+971', country: 'AE', flag: '🇦🇪', length: 9, name: 'UAE' },
    { code: '+31', country: 'NL', flag: '🇳🇱', length: 9, name: 'Netherlands' },
    { code: '+966', country: 'SA', flag: '🇸🇦', length: 9, name: 'Saudi Arabia' },
    { code: '+20', country: 'EG', flag: '🇪🇬', length: 10, name: 'Egypt' },
    { code: '+234', country: 'NG', flag: '🇳🇬', length: 10, name: 'Nigeria' },
    { code: '+254', country: 'KE', flag: '🇰🇪', length: 10, name: 'Kenya' },
    { code: '+7', country: 'RU', flag: '🇷🇺', length: 10, name: 'Russia' },
    { code: '+90', country: 'TR', flag: '🇹🇷', length: 10, name: 'Turkey' },
    { code: '+82', country: 'KR', flag: '🇰🇷', length: 10, name: 'South Korea' },
    { code: '+66', country: 'TH', flag: '🇹🇭', length: 9, name: 'Thailand' },
    { code: '+60', country: 'MY', flag: '🇲🇾', length: 9, name: 'Malaysia' },
    { code: '+65', country: 'SG', flag: '🇸🇬', length: 8, name: 'Singapore' },
    { code: '+63', country: 'PH', flag: '🇵🇭', length: 10, name: 'Philippines' },
    { code: '+62', country: 'ID', flag: '🇮🇩', length: 10, name: 'Indonesia' },
    { code: '+84', country: 'VN', flag: '🇻🇳', length: 9, name: 'Vietnam' },
    { code: '+880', country: 'BD', flag: '🇧🇩', length: 10, name: 'Bangladesh' },
    { code: '+32', country: 'BE', flag: '🇧🇪', length: 9, name: 'Belgium' },
    { code: '+46', country: 'SE', flag: '🇸🇪', length: 9, name: 'Sweden' },
    { code: '+47', country: 'NO', flag: '🇳🇴', length: 8, name: 'Norway' },
    { code: '+45', country: 'DK', flag: '🇩🇰', length: 8, name: 'Denmark' },
    { code: '+358', country: 'FI', flag: '🇫🇮', length: 9, name: 'Finland' },
    { code: '+48', country: 'PL', flag: '🇵🇱', length: 9, name: 'Poland' },
    { code: '+30', country: 'GR', flag: '🇬🇷', length: 10, name: 'Greece' },
    { code: '+351', country: 'PT', flag: '🇵🇹', length: 9, name: 'Portugal' },
    { code: '+420', country: 'CZ', flag: '🇨🇿', length: 9, name: 'Czech Republic' },
    { code: '+43', country: 'AT', flag: '🇦🇹', length: 10, name: 'Austria' },
    { code: '+41', country: 'CH', flag: '🇨🇭', length: 9, name: 'Switzerland' },
    { code: '+353', country: 'IE', flag: '🇮🇪', length: 9, name: 'Ireland' },
    { code: '+64', country: 'NZ', flag: '🇳🇿', length: 9, name: 'New Zealand' },
    { code: '+54', country: 'AR', flag: '🇦🇷', length: 10, name: 'Argentina' },
    { code: '+56', country: 'CL', flag: '🇨🇱', length: 9, name: 'Chile' },
    { code: '+57', country: 'CO', flag: '🇨🇴', length: 10, name: 'Colombia' },
    { code: '+51', country: 'PE', flag: '🇵🇪', length: 9, name: 'Peru' },
    { code: '+58', country: 'VE', flag: '🇻🇪', length: 10, name: 'Venezuela' },
    { code: '+972', country: 'IL', flag: '🇮🇱', length: 9, name: 'Israel' }
  ];

  useEffect(() => {
    let isMounted = true;
    
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setFormData(prev => ({ ...prev, serviceType: initialType }));
      
      // Fetch country info and auto-select dial code when modal opens
      const loadCountryInfo = async () => {
        try {
          const countryInfo = await getCountryInfo();
          if (isMounted && countryInfo && countryInfo.dialCode) {
            setFormData(prev => ({ ...prev, countryCode: countryInfo.dialCode }));
          }
        } catch (error) {
          console.error('Error loading country info:', error);
          // Silently fail - form will use default +1
        }
      };
      
      loadCountryInfo();
    } else {
      document.body.style.overflow = 'unset';
      setIsSubmitted(false);
      setErrors({});
      setApiError('');
    }
    
    return () => {
      isMounted = false;
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, initialType]);

  const validatePhone = (phone, countryCode) => {
    const cleanPhone = phone.replace(/\D/g, '');
    // Phone must have at least 7 digits
    if (cleanPhone.length < 7) return false;
    
    const selectedCountry = countryCodes.find(c => c.code === countryCode);
    if (!selectedCountry) {
      // If country not in list, accept 7-15 digit numbers
      return cleanPhone.length >= 7 && cleanPhone.length <= 15;
    }
    // Check exact length for known countries
    return cleanPhone.length === selectedCountry.length;
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!validatePhone(formData.phone, formData.countryCode)) {
      const selectedCountry = countryCodes.find(c => c.code === formData.countryCode);
      if (selectedCountry) {
        newErrors.phone = `Phone must be ${selectedCountry.length} digits`;
      } else {
        newErrors.phone = 'Invalid phone number';
      }
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Invalid email format';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setApiError('');
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    // Conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', { 
        send_to: 'AW-CONVERSION_ID/LABEL',
        event_category: formData.serviceType
      });
    }
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: formData.serviceType
      });
    }

    // Submit to API
    await handleFormSubmission(
      formData,
      (result) => {
        // Success callback
        console.log('Lead submitted successfully:', result);
        setIsSubmitted(true);
        setIsSubmitting(false);
        // Modal will stay open briefly then redirect happens automatically
      },
      (error) => {
        // Error callback
        console.error('Lead submission error:', error);
        setApiError(error);
        setIsSubmitting(false);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md transform transition-all">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Content */}
          <div className="p-8">
            {isSubmitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Send className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Thank You!</h3>
                <p className="text-gray-600">
                  {formData.serviceType === 'attorney' 
                    ? 'An attorney will contact you within 24 hours.'
                    : 'We\'ll contact you within 24 hours to begin your trademark registration.'}
                </p>
              </div>
            ) : (
              <>
                {/* Header */}
                <div className="text-center mb-6">
                  <div className="w-12 h-12 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
                    {formData.serviceType === 'attorney' ? (
                      <MessageCircle className="w-6 h-6 text-white" />
                    ) : (
                      <Send className="w-6 h-6 text-white" />
                    )}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {formData.serviceType === 'attorney' 
                      ? 'Discuss with an Attorney'
                      : 'Start Your Trademark Registration'}
                  </h3>
                  <p className="text-gray-600">
                    Fill out the form below and our expert will contact you within 24 hours
                  </p>
                </div>

                {/* API Error Display */}
                {apiError && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
                    <p className="text-sm">{apiError}</p>
                  </div>
                )}

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 border ${errors.name ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent`}
                      placeholder="Your Name *"
                    />
                    {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                  </div>

                  <div>
                    <div className="flex gap-2">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        className="w-24 px-2 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent text-sm"
                      >
                        {countryCodes.map((country, idx) => (
                          <option key={idx} value={country.code}>
                            {country.flag} {country.code}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className={`flex-1 px-4 py-3 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent`}
                        placeholder="Phone Number *"
                      />
                    </div>
                    {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                  </div>

                  <div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent`}
                      placeholder="Your Email *"
                    />
                    {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="brandName"
                      value={formData.brandName}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent"
                      placeholder="Brand Name (Optional)"
                    />
                  </div>

                  <div>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="3"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent resize-none"
                      placeholder="Tell us about your brand or questions (Optional)"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-6 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {isSubmitting ? (
                      'Submitting...'
                    ) : formData.serviceType === 'attorney' ? (
                      <>
                        <MessageCircle className="w-5 h-5" />
                        Request Consultation
                      </>
                    ) : (
                      <>
                        <Send className="w-5 h-5" />
                        Start Registration
                      </>
                    )}
                  </button>

                  <p className="text-center text-gray-500 text-xs">
                    No credit card required • Free consultation
                  </p>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationModal;
